import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import './register.css';
import { useNavigate } from "react-router-dom";

const Register = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const onFinish = (values) => {
    console.log('Received values of form: ', { ...values, email });
    verifyCode({ ...values, email })

  };

  const sendVerificationCode = async () => {
    try {
      await fetch('//dai.caihuiltd.com/api/send-verification-code', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify({ email }),
      });
      message.success('Verification code sent to your email.');
    } catch (error) {
      console.error('Error sending verification code:', error);
    }
  };

  const register = async (values) => {
    try {
      const res = await fetch('//dai.caihuiltd.com/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(values),
      });
      const data = await res.json();
      console.log(data);
      if (data.message === 'User registered successfully') {
        message.success('Register successful');
        navigate("/login");
      }
    } catch (error) {
      message.console.error("This account has already been registered ");
      console.error('Error registering user:', error);
    }
  };

  const verifyCode = async (values) => {
    try {
      const res = await fetch('//dai.caihuiltd.com/api/verify-code', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(values),
      });
      if (res.ok) {
        const data = await res.json();
        console.log(data);
        register(values); // 只有在验证成功时才调用
      } else {
        throw new Error('Invalid verification code');
      }
    } catch (error) {
      message.open({
        type: 'error',
        content: 'Invalid verification code',
      });
      console.error('Error verifying code:', error);
    }
  };

  return (
    <div className="register-container">
      <h1>Register</h1>
      <Form
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="name"
          rules={[{ message: 'Please enter username!' }]}
        >
          <Input placeholder="Please enter username" />
        </Form.Item>
        <Form.Item
          name="email"
          label="email"
          rules={[
            {
              type: 'email',
              message: 'Please enter a valid email address!',
            },
          ]}
        >
          <Input
            placeholder="Please enter a valid email address"
            value={email}
            onChange={handleEmailChange}
          />

        </Form.Item>
        <Form.Item
          name="verificationCode"
          label=" code"
          rules={[{ message: 'code' }]}
        >
          <Input placeholder="code" className='codeinput' />
          <Button className='codebut' onClick={sendVerificationCode}>
            send
          </Button>
        </Form.Item>
        <Form.Item
          name="password"
          label="password"
          rules={[{ message: 'Please enter password!' }]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" className='submitbut'>
            Register
          </Button>
        </Form.Item>
        <Button type="link" className='submitbut' onClick={() => navigate("/login")}>
          Already have an account?
        </Button>
      </Form>
    </div>
  );
};

export default Register;
